import React from "react";
import request from "arcdynamic-request";
import {SELLERS} from "../../consts/tables";
import {SELLERS_LIST_COUNT} from "../../consts/queries";
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { executeQuery } from "../../requests/executeQuery";
import { getData } from "../../requests/CRUD";

const cloneDeep = require("lodash.clonedeep");
const limit = 1000;

class SelectSeller extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
        };
    }

    componentDidMount() {
        executeQuery({queryName: SELLERS_LIST_COUNT})
        .then((res)=>{
            let totalRequest = Math.round(res.data[0].TOTAL_COUNT/1000);
            let requests = [];
            let offset = 0;
            for(let i=totalRequest; i>0;i--){
                requests.push(getData({
                    tableCode: SELLERS,
                    options: {
                        limit: {
                            count: limit,
                            offset: offset * limit,
                        },
                        column: [
                            "ARCIMEDES_ROW_ID",
                            "FIRST_NAME",
                            "LAST_NAME",
                            "COMPANY_NAME",
                        ],
                        filterType: "and",
                        filter: [
                            {
                                code: "DELETED",
                                text: "",
                                type: "null",
                            },
                        ],
                        order: [
                            {
                                code: "FIRST_NAME",
                                type: "asc",
                            },
                            {
                                code: "LAST_NAME",
                                type: "asc",
                            },
                            {
                                code: "COMPANY_NAME",
                                type: "asc",
                            },
                        ],
                    },
                }));
                ++offset;
            }
        Promise.all(requests).then((res) => {
            if(res){
                var items = []
                res.forEach((resp)=>{
                    if(resp && resp.success){
                        items = [...items, ...resp.data]
                    }
                })
                items = items.filter(item => item.FIRST_NAME !== '' || item.LAST_NAME !== '' || item.COMPANY_NAME !== '')
                this.setState({items});
            }
          })
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newSeller !== nextProps.newSeller) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newSeller);
            this.setState({items});
        }
    }

    render() {
        const {items} = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            handleParentChange,
            addNewItem,
            deleted,
            viewMode,
            ...rest
        } = this.props;

        return (
            <Dropdown
                theme={theme}
                optionsType="seller"
                optionKey="ARCIMEDES_ROW_ID"
                options={items}
                value={value}
                valueKey={valueKey}
                label={label}
                disabled={!items || disabled}
                data={data}
                withAddNew={withAddNew}
                handleParentChange={handleParentChange}
                addNewItem={addNewItem}
                deleted={deleted}
                viewMode={viewMode}
                {...rest}
            />
        );
    }
}

SelectSeller.propTypes = {
    theme: PropTypes.oneOf(["default", "white", "dark"]),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectSeller;
